export const SUPPORTED_LOCALES = {
  en: 'English',
  // es: 'Español',
  //pt: 'Português',
  //zh: '中国人'
};
export const DEFAULT_LOCALE = 'en';